import { useCallback } from 'react';

export const useAccessControl = (permissions, options = { notPermissionPolicy: 'forbidden' }) =>
  useCallback(
    permissionKey => {
      if (!permissions && options.notPermissionPolicy === 'allowed') {
        return true;
      } else if (!permissions || permissions.length === 0) {
        return false;
      }

      return permissions.includes(permissionKey);
    },
    [permissions?.length],
  );
